// Original illustrated icons for the Rip a Pack cards (100×100 viewBox, flat shapes).
// Drawn for this site from each character's best-known look; not official artwork.
window.CHAR_ART = {
  'Darth Vader': `
    <line x1="10" y1="92" x2="92" y2="8" stroke="#ff3b30" stroke-width="5" stroke-linecap="round" opacity=".9"/>
    <line x1="10" y1="92" x2="92" y2="8" stroke="#ffd2cc" stroke-width="1.6" stroke-linecap="round"/>
    <path d="M50 12C29 12 21 29 21 47L15 77 31 86 38 71H62L69 86 85 77 79 47C79 29 71 12 50 12Z" fill="#141418" stroke="#4a4a58" stroke-width="1.5"/>
    <path d="M27 46C33 36 44 33 50 33S67 36 73 46" fill="none" stroke="#3a3a46" stroke-width="2"/>
    <path d="M30 47L46 46 44 55 33 54Z" fill="#2c2c36"/><path d="M70 47L54 46 56 55 67 54Z" fill="#2c2c36"/>
    <path d="M50 44V58" stroke="#5a5a68" stroke-width="2"/>
    <path d="M41 60H59L55 76H45Z" fill="#6c6c7a"/>
    <path d="M44 64H56M45 68H55M46 72H54" stroke="#2a2a32" stroke-width="1.4"/>`,

  'Darth Maul': `
    <path d="M32 26L35 14 39 26M46 22L50 9 54 22M61 26L65 14 68 26M40 33L42 25 45 33M55 33L58 25 60 33" fill="#efe6cf"/>
    <path d="M50 22C31 22 25 38 25 54C25 74 37 90 50 90S75 74 75 54C75 38 69 22 50 22Z" fill="#c4232b"/>
    <path d="M50 22V40M35 30L44 44M65 30L56 44M28 52H40L44 60M72 52H60L56 60M40 72L47 80V90M60 72L53 80V90M44 64H56" stroke="#141414" stroke-width="5" fill="none" stroke-linecap="round"/>
    <path d="M36 50L46 52 44 56 37 55Z" fill="#141414"/><path d="M64 50L54 52 56 56 63 55Z" fill="#141414"/>
    <circle cx="41" cy="53" r="2.3" fill="#ffcf2e"/><circle cx="59" cy="53" r="2.3" fill="#ffcf2e"/>`,

  'Grand Admiral Thrawn': `
    <path d="M24 92C26 78 36 72 50 72S74 78 76 92Z" fill="#eef0f4"/>
    <path d="M40 72H60V80H40Z" fill="#d6d9e0"/><rect x="62" y="80" width="8" height="4" rx="1" fill="#e2b33b"/>
    <path d="M50 16C34 16 28 30 28 44C28 60 37 74 50 74S72 60 72 44C72 30 66 16 50 16Z" fill="#3d72d6"/>
    <path d="M27 40C27 22 38 12 52 12S75 22 73 40C68 30 60 26 50 26S34 30 27 40Z" fill="#101318"/>
    <path d="M35 46L46 47 45 51 36 50Z" fill="#ff2e2e"/><path d="M65 46L54 47 55 51 64 50Z" fill="#ff2e2e"/>
    <circle cx="41" cy="48.5" r="5" fill="#ff2e2e" opacity=".25"/><circle cx="59" cy="48.5" r="5" fill="#ff2e2e" opacity=".25"/>
    <path d="M44 63H56" stroke="#1f3f86" stroke-width="2" stroke-linecap="round"/>`,

  'Ahsoka Tano': `
    <path d="M30 30C20 40 18 62 22 92H34C30 70 32 50 38 38Z" fill="#f2f2f2"/>
    <path d="M70 30C80 40 82 62 78 92H66C70 70 68 50 62 38Z" fill="#f2f2f2"/>
    <path d="M23 52L33 46M22 64L32 60M23 76L33 74M77 52L67 46M78 64L68 60M77 76L67 74" stroke="#2f6fd0" stroke-width="4" stroke-linecap="round"/>
    <path d="M50 22C36 22 31 36 31 50C31 66 39 80 50 80S69 66 69 50C69 36 64 22 50 22Z" fill="#e8823a"/>
    <path d="M30 34C34 18 66 18 70 34C64 28 58 26 50 26S36 28 30 34Z" fill="#f2f2f2"/>
    <path d="M50 26L44 36H56Z" fill="#f2f2f2"/>
    <path d="M36 48L44 44 46 48M64 48L56 44 54 48" stroke="#f2f2f2" stroke-width="2.6" fill="none" stroke-linecap="round"/>
    <circle cx="42" cy="52" r="2.4" fill="#1a3d7a"/><circle cx="58" cy="52" r="2.4" fill="#1a3d7a"/>
    <path d="M44 66L50 70 56 66" stroke="#f2f2f2" stroke-width="2.6" fill="none" stroke-linecap="round"/>`,

  'Sabine Wren': `
    <path d="M50 12C30 12 22 28 22 46V80L32 88H68L78 80V46C78 28 70 12 50 12Z" fill="#7a4fc9"/>
    <path d="M22 46C22 28 30 12 50 12V30C38 30 30 36 26 46Z" fill="#f08a3c"/>
    <path d="M58 14C68 18 76 28 78 42L66 40C64 30 60 22 54 18Z" fill="#ffd23f"/>
    <path d="M30 42H70V52H56V82H44V52H30Z" fill="#101016"/>
    <path d="M22 66H32M68 66H78" stroke="#ff4f8b" stroke-width="4"/>
    <circle cx="74" cy="30" r="3" fill="#2fd3c6"/>`,

  'The Mandalorian': `
    <path d="M50 12C30 12 22 28 22 46V80L32 88H68L78 80V46C78 28 70 12 50 12Z" fill="#b9bfca"/>
    <path d="M50 12C40 12 33 16 29 24C38 20 44 19 50 19S62 20 71 24C67 16 60 12 50 12Z" fill="#e6eaf1"/>
    <path d="M28 40H72V50H56V82H44V50H28Z" fill="#0d0f14"/>
    <path d="M24 56C24 64 26 72 30 78M76 56C76 64 74 72 70 78" stroke="#8a919d" stroke-width="2" fill="none"/>
    <path d="M30 30L40 28M60 28L70 30" stroke="#8a919d" stroke-width="1.5"/>`,

  'Grogu': `
    <path d="M8 40C20 34 32 38 38 46L34 56C24 56 14 50 8 40Z" fill="#7fae6a"/>
    <path d="M92 40C80 34 68 38 62 46L66 56C76 56 86 50 92 40Z" fill="#7fae6a"/>
    <path d="M14 41C22 39 30 42 34 48" stroke="#e8a4a0" stroke-width="3" fill="none" opacity=".7"/>
    <path d="M86 41C78 39 70 42 66 48" stroke="#e8a4a0" stroke-width="3" fill="none" opacity=".7"/>
    <path d="M26 88C28 74 38 68 50 68S72 74 74 88Z" fill="#c9a774"/>
    <path d="M50 26C36 26 30 38 30 50C30 62 38 72 50 72S70 62 70 50C70 38 64 26 50 26Z" fill="#8cbd76"/>
    <ellipse cx="41" cy="50" rx="6" ry="7" fill="#15110d"/><ellipse cx="59" cy="50" rx="6" ry="7" fill="#15110d"/>
    <circle cx="43" cy="47" r="1.8" fill="#fff"/><circle cx="61" cy="47" r="1.8" fill="#fff"/>
    <path d="M46 63C48 65 52 65 54 63" stroke="#4d6f3e" stroke-width="2" fill="none" stroke-linecap="round"/>`,

  'Boba Fett': `
    <path d="M74 20V6" stroke="#9aa0a8" stroke-width="2.5"/><circle cx="74" cy="6" r="2" fill="#9aa0a8"/>
    <path d="M50 14C30 14 22 30 22 48V80L32 88H68L78 80V48C78 30 70 14 50 14Z" fill="#5f7f52"/>
    <path d="M50 14C38 14 30 20 26 30H74C70 20 62 14 50 14Z" fill="#4f6b44"/>
    <path d="M28 40H72V50H56V82H44V50H28Z" fill="#101410"/>
    <path d="M28 36H72" stroke="#c43a2e" stroke-width="4"/>
    <path d="M60 60L66 66M64 56L70 62" stroke="#3b3b3b" stroke-width="2"/>
    <path d="M26 58H32V76H26Z" fill="#c43a2e"/>`,

  'Luke Skywalker': `
    <circle cx="34" cy="30" r="12" fill="#ffb347" opacity=".9"/><circle cx="62" cy="22" r="8" fill="#ffd27a" opacity=".9"/>
    <path d="M0 78C20 70 40 74 60 70S90 66 100 70V100H0Z" fill="#c99a5b" opacity=".55"/>
    <line x1="50" y1="78" x2="50" y2="20" stroke="#3dff6e" stroke-width="7" stroke-linecap="round" opacity=".45"/>
    <line x1="50" y1="78" x2="50" y2="20" stroke="#d9ffe0" stroke-width="3" stroke-linecap="round"/>
    <rect x="45" y="76" width="10" height="20" rx="2" fill="#c7cbd3"/>
    <path d="M45 82H55M45 88H55" stroke="#2b2b30" stroke-width="2"/>
    <rect x="47" y="73" width="6" height="4" fill="#2b2b30"/>`,

  'Leia Organa': `
    <circle cx="24" cy="50" r="14" fill="#5a3824"/><circle cx="76" cy="50" r="14" fill="#5a3824"/>
    <path d="M18 50C18 44 22 40 28 40M82 50C82 44 78 40 72 40M20 56C24 60 30 60 32 56M80 56C76 60 70 60 68 56" stroke="#3e2617" stroke-width="2" fill="none"/>
    <path d="M30 92C32 80 40 76 50 76S68 80 70 92Z" fill="#f2f2f2"/>
    <path d="M50 24C38 24 33 36 33 48C33 62 40 76 50 76S67 62 67 48C67 36 62 24 50 24Z" fill="#f1c8a6"/>
    <path d="M32 46C32 30 40 20 50 20S68 30 68 46C64 36 58 32 50 32S36 36 32 46Z" fill="#5a3824"/>
    <circle cx="43" cy="50" r="2.2" fill="#3b2416"/><circle cx="57" cy="50" r="2.2" fill="#3b2416"/>
    <path d="M45 64C48 66 52 66 55 64" stroke="#b05a52" stroke-width="2" fill="none" stroke-linecap="round"/>`,

  'Han Solo': `
    <path d="M50 30C26 30 10 40 10 54S26 78 50 78 90 68 90 54 74 30 50 30Z" fill="#c9ccd2"/>
    <path d="M50 38C34 38 22 45 22 54S34 70 50 70 78 63 78 54 66 38 50 38Z" fill="none" stroke="#9aa0aa" stroke-width="1.5"/>
    <path d="M12 46L2 40V50L12 52ZM12 62L2 68V58L12 56Z" fill="#c9ccd2"/>
    <path d="M78 64C84 66 90 70 92 74L84 78C80 74 76 70 72 68Z" fill="#b8bcc4"/>
    <circle cx="86" cy="76" r="5" fill="#2a2d33" stroke="#c9ccd2" stroke-width="2"/>
    <circle cx="50" cy="54" r="7" fill="#9aa0aa"/><circle cx="50" cy="54" r="3" fill="#6a707a"/>
    <path d="M30 44L40 48M60 60L70 64M60 46L72 42" stroke="#8a909a" stroke-width="2"/>
    <path d="M10 54H2" stroke="#7fc8ff" stroke-width="2" opacity=".8"/>`,

  'Obi-Wan Kenobi': `
    <line x1="80" y1="96" x2="80" y2="34" stroke="#3aa0ff" stroke-width="7" stroke-linecap="round" opacity=".45"/>
    <line x1="80" y1="96" x2="80" y2="34" stroke="#d6ecff" stroke-width="3" stroke-linecap="round"/>
    <path d="M50 10C28 10 18 30 18 52C18 72 22 86 26 96H74C78 86 82 72 82 52C82 30 72 10 50 10Z" fill="#7a5a3c"/>
    <path d="M50 26C38 26 32 38 32 50C32 64 40 78 50 78S68 64 68 50C68 38 62 26 50 26Z" fill="#2a1d14"/>
    <path d="M50 34C41 34 37 42 37 52C37 58 39 62 42 64H58C61 62 63 58 63 52C63 42 59 34 50 34Z" fill="#e3b892"/>
    <path d="M40 58C40 70 45 78 50 78S60 70 60 58C56 62 53 63 50 63S44 62 40 58Z" fill="#c9a37a"/>
    <circle cx="45" cy="50" r="1.8" fill="#2a1d14"/><circle cx="55" cy="50" r="1.8" fill="#2a1d14"/>`,
};
